export const UserRole = Object.freeze({
    CLIENT: "client",
    ADMIN: "admin",
    SUPER_ADMIN: "superAdmin",
  });
  
  
  